import { channelPreview } from "../../../../data";

const { shop, offer, email } = channelPreview;

// The campaign as an email: window bar, sender, subject, then a branded
// offer banner, the code and a (decorative) button.
const EmailPreview = () => (
  <div className="w-full max-w-[320px] overflow-hidden rounded-2xl border border-line bg-white text-ink shadow-lift">
    <div aria-hidden="true" className="flex gap-1.5 bg-paper px-3.5 py-2.5">
      <i className="size-2.5 rounded-full bg-line" />
      <i className="size-2.5 rounded-full bg-line" />
      <i className="size-2.5 rounded-full bg-line" />
    </div>
    <div className="flex items-center gap-2.5 px-4 pt-3 pb-2">
      <span className="grid size-8 shrink-0 place-items-center rounded-full bg-primary text-sm font-extrabold text-white">
        {shop.initial}
      </span>
      <div className="min-w-0">
        <b className="block text-[13px]">{shop.name}</b>
        <small className="block truncate text-[11.5px] text-ink-muted">
          {shop.email}
        </small>
      </div>
    </div>
    <div className="grid gap-0.5 border-b border-line px-4 pb-3">
      <b className="text-sm leading-snug">{email.subject}</b>
      <small className="text-xs text-ink-muted">{email.preheader}</small>
    </div>
    <div className="grid gap-3 bg-cream p-4">
      <div className="grid gap-1 rounded-xl bg-brand-gradient px-4 py-5 text-white">
        <small className="text-[11px] font-bold tracking-[0.08em] uppercase opacity-90">
          {offer.title}
        </small>
        <b className="text-2xl leading-tight font-extrabold">{offer.value}</b>
        <small className="text-xs opacity-90">{offer.detail}</small>
      </div>
      <p className="text-[13px] leading-relaxed">
        {email.greeting} {email.body}
      </p>
      <span className="justify-self-start rounded-lg border border-dashed border-primary px-3 py-1.5 text-[13px] font-extrabold tracking-[0.08em] text-primary">
        {offer.code}
      </span>
      <span
        aria-hidden="true"
        className="justify-self-start rounded-lg bg-primary px-4 py-2 text-[13px] font-bold text-white"
      >
        {offer.button}
      </span>
      <small className="text-[11px] leading-snug text-ink-muted">
        {email.footer}
      </small>
    </div>
  </div>
);

export default EmailPreview;
